import { render } from "./BillingWallet.vue?vue&type=template&id=0b512fcc"
import script from "./BillingWallet.vue?vue&type=script&lang=js"
export * from "./BillingWallet.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__